import React from 'react';
import { DrivingSlipFilter } from './DrivingSlipOverview';
import { useGetDrivingSlipsExcelLazyQuery, DrivingSlipStatus } from '@ssg/common/GraphQL/indexV2';
import { formatDateForInput } from '@ssg/common/Helpers/dateToDateOnlyString';
import useSaveFile from '@ssg/common/Hooks/useSaveFile';
import { useTranslation } from 'react-i18next';
import Button from '@ssg/common/Components/Button';
import TextButton from '@ssg/common/Components/TextButton';
import { faFileExcel, faSpinner } from '@fortawesome/pro-regular-svg-icons';

interface Props {
	activeFilters: DrivingSlipFilter;
	searchTerm?: string;
}

const DrivingSlipExportToExcel: React.FC<Props> = ({ activeFilters, searchTerm }): React.ReactElement => {
	const { t } = useTranslation();

	const [exportListToExcel, { loading, data }] = useGetDrivingSlipsExcelLazyQuery({
		fetchPolicy: 'network-only',
		nextFetchPolicy: 'no-cache',
	});

	useSaveFile(data?.exportDrivingSlipsToExcel, `${t('drivingSlips.overviewTitle')} - ${formatDateForInput(new Date())}.xlsx`);
	return (
		<TextButton
			link
			icon={faFileExcel}
			text="common.exportForExcel"
			onClick={() =>
				exportListToExcel({
					variables: {
						urgent: activeFilters.urgent,
						exceeded: activeFilters.exceeded,
						departments: activeFilters.departments,
						locations: activeFilters.locations,
						damageCauses: activeFilters.damageCauses,
						damageCategories: activeFilters.damageCategories,
						drivers: activeFilters.drivers,
						debitor: activeFilters.debitors,
						minStartDate: activeFilters.minStartDate ? formatDateForInput(new Date(activeFilters.minStartDate ?? '')) : undefined,
						maxStartDate: activeFilters.maxStartDate ? formatDateForInput(new Date(activeFilters.maxStartDate ?? '')) : undefined,
						minEndDate: activeFilters.minEndDate ? formatDateForInput(new Date(activeFilters.minEndDate ?? '')) : undefined,
						maxEndDate: activeFilters.maxEndDate ? formatDateForInput(new Date(activeFilters.maxEndDate ?? '')) : undefined,
						noDriver: activeFilters.noDriver,
						priorityCustomers: activeFilters.showPriorityCustomerCases,
						status: activeFilters.status as DrivingSlipStatus | null,
						offset: 0,
						limit: 20,
						searchString: searchTerm || null,
					},
				})
			}
			loading={loading}
			disabled={loading}
		/>
	);
};

export default DrivingSlipExportToExcel;

